define('root/Assets/Js/Ajax',[
	'jquery',
	'base/MbiHelper',
	'base/MbiMediaQuery',
	'project/MbiConfig',
	'base/MbiImageSize',
	'base/Vendor/History'
], function(
	$,
	_,
	mbiMq,
	mbiConfig,
	mbiImageSize
) {
	'use strict';

/*
	Ajax Handler for loading pages via Ajax Get Request.
	Works with every Link to an internal page (i.e. Menu Link)
	Href necessary
	simply add class 'js_ajax' for required workflow

	See Ajax.php sample page for infos how to return content
	from a page.

*/
	var module = {
		ajaxhandler: '.js_ajax',
		noajax: 'js_no_ajax',
		fadeout: 'is_fading_out',
		contentContainer: '.site',
		initPageId: 1,
		initLang: 'de',
		initBodyClasses: [],
		initLangDe: '',
		initLangEn: '',


		decodeHTMLEntities: function(text) {
			var entities = [
				['apos', '\''],
				['amp', '&'],
				['lt', '<'],
				['gt', '>'],
				['quot', '"'],
				['#039', '\''],
				['raquo', '|'],
				['&#8217;', '|'],

			];

			for (var i = 0, max = entities.length; i < max; ++i)
				text = text.replace(new RegExp('&'+entities[i][0]+';', 'g'), entities[i][1]);

			return text;
		},

		setMenu: function(clearMenu,pageID){
			if(clearMenu){
				$('.menu__item--active').removeClass('menu__item--active menu__item--current');
				$('.menu__entry--active').removeClass('menu__entry--active');
			}

			if(pageID){
				$('.menu__item.menuID'+pageID).addClass('menu__item--active menu__item--current');
				$('.menu__entry.menuID'+pageID).addClass('menu__entry--active');
			}
		},

		init: function(){

			module.initPageId = parseInt($('body').attr('class').match(/\d+/)[0], 10);

			if($('html').attr('lang')=='en-US'){
				module.initLang = 'en';
			}

			module.initLangDe = $($('#langnav a')[0]).attr('href');
			module.initLangEn = $($('#langnav a')[1]).attr('href');

			$(document).on('click', module.ajaxhandler, function(e) {
			    if($(this).hasClass('js_hover-special') && !$(this).parents('.js_hover').hasClass('is_active')) {
			        e.preventDefault();
			    } else {
				if(!$(this).hasClass(module.noajax)) {
					e.preventDefault();
					if($(this).attr('href')) {
						var $url = $(this).attr('href');
					} else {
						$url = $(this).attr('data-href');
					}

					if($url != location.href) {
						module.pagetransition('out');
						var $name = $(this).attr('data-name');
						$(module.contentContainer).addClass(module.fadeout);
						$('#topnav').removeClass('is_open');
						$(document).find('.menu__level1').removeClass('is_open');
						if($(this).parent().hasClass('menu__item')) {
							$('.menu__item--active').removeClass('menu__item--active menu__item--current');
							$('.menu__entry--active').removeClass('menu__entry--active');
							// $(this).parent().addClass('menu__item--active menu__item--current');
							// $(this).addClass('menu__entry--active');
							var menuitem = $(this).parent().attr('class').split(' ');
							var menuentry = $(this).attr('class').split(' ');
							$('.' + menuitem[1]).addClass('menu__item--active menu__item--current'),
							$('.' + menuentry[1]).addClass('menu__entry--active');
							// $(this).addClass('menu__item--current menu__item--active');
							// $(this).find('a').addClass('menu__entry--active');
						}
												// module.setMenu(true,false);

						$.ajax({
							url: $url,
							dataType: 'json',
							data: {},
							timeout: 8000
						})
						.done(function(data) {


							var curLang2 = 'de';
							if($('html').attr('lang')=='en-US'){
								curLang2 = 'en';
							}

							// var bodyClasses = data['bodyClass'].join(' ');
							// $('body').attr('class',bodyClasses);

								var bodyCl = '';
								$.each(data.bodyclass, function(index, val) {
									var t = ' ' + val;
									bodyCl += t;
								});

								// $('.langSelector').find('.is_active_lang').siblings('div').find('a').attr('href', data.urlLang);

								$('body').removeClass().addClass(bodyCl);
							var compressedContent = data.content;

							var menuitem = $('.menu__item--active.menu__item--current');
							if(menuitem.length > 0) {
								var $classitem = menuitem.attr('class').split(' ');
							} else {
								var $classitem = ['',''];
							}

							var menuentry = $('.menu__entry--active');
							if(menuentry.length > 0) {
								var $classentry = menuentry.attr('class').split(' ');
							} else {
								var $classentry = ['',''];
							}

							if($('body').hasClass('home')) {
								$('.menu__item--active').removeClass('menu__item--active');
								$('.menu__entry--active').removeClass('menu__entry--active');
							}
							// $('.' + classitem[1]).addClass('menu__item--active menu__item--current'),
							// $('.' + classentry[1]).addClass('menu__entry--active');
							// console.log($classitem[1], $classentry[1]);
								var entities = [
									['apos', '\''],
									['amp', '&'],
									['lt', '<'],
									['gt', '>'],
									['quot', '"'],
									['#039', '\''],
									['&raquo;', '|'],

								];
								// var newti = data.title.replace('&raquo;', '»');
								// var newti = data.title.replace('&#8217', '\"');
							history.pushState({
								//'url': 			data.url,
								'url': 			$url,
								'deUrl': 		data.deUrl,
								'enUrl': 		data.enUrl,
								'title': 		data.title,
								'origin': 		location.href,
								'content': 		compressedContent,
								'langcode': curLang2,
								'bodyClass': bodyCl,
								'navitem': '.' + $classitem[1],
								'naventry': '.' + $classentry[1],
								'id' : data.id,
								'mode': 		'history'
							}, data.title, $url);

							// module.setMenu(true,data.id);
							//console.log(data.content);
							// setTimeout(function(){
								$(module.contentContainer).html(data.content);
								$('body, html').scrollTop(0);
								setTimeout(function(){
									$(module.contentContainer).removeClass('is_fading_out');
								},200);
									module.pagetransition('in');

							    // $('.site, .navColor').removeClass('is_orange is_blue is_yellow is_green is_turquoise');
							    // $('.site, .navColor').addClass('is_'+data.color);
								// $('.menu-button').html($('.menu-button').attr('data-closed'));


								$(document).trigger('AjaxSwapDone');
								document.title = data.title;
								mbiImageSize.init();
								// initAll();

							// }, 100);

						})
						.fail(function() {
							location.href = $url;

						})
						.always(function() {
						});
					}
				}
			}
			});

			$(document).on('AjaxSwapDone', function(){

				setTimeout(function(){
					module.initAll();
				},1);
			});

			$(window).on('popstate', function(event) {

					$(module.contentContainer).addClass(module.fadeout);

/* NEW */


//console.log("ajax popstate");
				if(history.state){//for #anchor klicks
					module.pagetransition('out');
				if(history.state.content){
//console.log('popstate',history.state.id);
					$('.menu__item--active').removeClass('menu__item--active menu__item--current');
					$('.menu__entry--active').removeClass('menu__entry--active');
					$(history.state.navitem).addClass('menu__item--active menu__item--current');
					$(history.state.naventry).addClass('menu__entry--active');

					var content = history.state.content;

					// module.setMenu(true,history.state.id);

					//$('body, html').animate({scrollTop: 0 },400, function() {});

					setTimeout(function(){
						$(module.contentContainer).html(content);

						//console.log(history.state.bodyClass);

						var bodyClasses = '';
						var bodyClassArray = [];

						if(Array.isArray(history.state.bodyClass)){
							bodyClasses = history.state.bodyClass.join(' ');
							bodyClassArray = history.state.bodyClass;
						} else {
							bodyClasses = history.state.bodyClass;
							bodyClassArray = history.state.bodyClass.split(" ");
						}

						$('body').attr('class',bodyClasses);

						var data = {
							'bodyClass' : bodyClassArray,
							'langcode' : history.state.langcode,
							'id' : history.state.id
						}

						document.title = history.state.title;
						//$('body, html').animate({scrollTop: 0 },0, function() {});
						$('body, html').scrollTop(0);

						$(module.contentContainer).removeClass(module.fadeout);
						module.pagetransition('in');
						$(document).trigger('AjaxSwapDone',data);
					}, 1000);
				}
				}
/* NEW END*/
/* OLD
			 //    $(module.contentContainer).addClass('is_fading_out');
			 //    var content = (window.event.state.content);
				// $('.menu__item').removeClass('menu__item--active').removeClass('menu__item--current');
				// $('.menu__entry').removeClass('menu__entry--active').removeClass('menu__entry--current');
				// $('.menu__entry--'+window.event.state.activeMenu).addClass('menu__entry--active').addClass('menu__entry--current');
				// $('.menu__item--'+window.event.state.activeMenu).addClass('menu__item--active').addClass('menu__item--current');
				// setTimeout(function(){
				// 	$(module.contentContainer).html(content);
				// 	$(module.contentContainer).removeClass('is_fading_out');
				// 	$(document).trigger('AjaxSwapDone');
				// }, 1);

*/
			});

				var compressedContent = $(module.contentContainer).html();
//console.log($(module.contentContainer).html().length,compressedContent.length);
				var menuitem = $('.menu__item--active.menu__item--current');
				if($('body').hasClass('single-immomakler_object')) {
					menuitem = $('.menu__item').first();
				}
				if(menuitem.length > 0) {
					var $classitem = menuitem.attr('class').split(' ');
					$('.' + $classitem[1]).addClass('menu__item--active menu__item--current');
					var navitem = '.' + $classitem[1];
				} else {
					var $classitem = ['',''];
					var navitem = '';
				}

				var menuentry = $('.menu__entry--active');
				if($('body').hasClass('single-immomakler_object')) {
					menuentry = $('.menu__entry').first();
				}
				if(menuentry.length > 0) {
					var $classentry = menuentry.attr('class').split(' ');
					$('.' + $classentry[1]).addClass('menu__entry--active');
					var naventry = '.' + $classentry[1];
				} else {
					var $classentry = ['',''];
					var naventry = '';
				}


			history.replaceState({
				'url': 			location.href,
				'deUrl': 		module.initLangDe,
				'enUrl': 		module.initLangEn,
				'title': 		document.title,
				'origin': 		location.href,
				'content': 		compressedContent,
				'navitem': 		navitem,
				'naventry': 	naventry,
				'mode': 		'history',
				'langcode': module.initLang,
				'bodyClass': module.initBodyClasses,
				'id' : module.initPageId,
			}, document.title, location.href);

			// window.addEventListener("beforeunload", function (e) {
			// 	history.replaceState({
			// 		'content': '<script>window.location.reload();</script>',
			// 	}, document.title, location.href);
			// });
		},
		initAll: function(){
			// mbiImageSize.init();

			//if you need a swiper or isotope or anything else,
			//initialize everything HERE
		},
		pagetransition: function(to) {
 			$('#topnav').removeClass('is_open');
			$('.menu-button').removeClass('is_open');
			$('.burger').removeClass('is_open');
			$('.hamburger').removeClass('is-active');
 			$('.transition-bg, .transition-bg-white').removeClass('animating-out').removeClass('animating-in');
			if(to == 'out') {
				$('#transition').css('display','block');
				setTimeout(function(){
			    	$('.transition-bg, .transition-bg-white').addClass('animating-out');
			    	$('.site').addClass('is-fadingout');
				},2)

				// $.bodyFix('is_menu_open');
	    	} else {
		     $('.transition-bg, .transition-bg-white').addClass('animating-in');

    	        setTimeout(function(){
		            $('#transition').css('display','none');
		            $('.site').removeClass('is-fadingout');
		            $('.transition-bg, .transition-bg-white').removeClass('animating-in');
		            mbiImageSize.init();
		        },300);
		    }


		}
	};

	if(!$('html').hasClass('touch')) {
		// console.log($('html').attr('data-browsername'));
		if(($('html').attr('data-browser-name') == 'safari') && ($('html').attr('data-browser-version') == '8')) {
			// console.log('jetzt nicht machen');
		} else {
			module.init();
		}
	}
	mbiConfig.modules.Ajax = {
		'init': 	true,
	};

	// -----------------------------------------------------------------

	return module;

});
